module.exports = __webpack_public_path__ + "static/media/9DESA27.a694eafe.jpg";